import React, { useEffect, useState } from "react"
import { createStructuredSelector } from "reselect"
import { withRouter } from "HOC/withRouter"
import { connect } from "react-redux"
import PropTypes from "prop-types"
import { compose } from "redux"

// Actions
import { setFilterValueAction, getWidgetDataAction } from "Containers/Page/actions"

// Selectors
import { selectActualWidgetsData } from "Containers/Page/selectors"

// Style
import {
  TooltipContainer,
  Header,
} from "Components/chartsLibrary/Map/tooltipPRNSN/index.style"

// Utils
import { getItemTooltip, makeData } from "Components/chartsLibrary/Map/tooltipPRNSN/utilsV2"
import {
  generateETLRequestJsonFromWidgetInfo,
  getCorrectRelatedPageFilter,
  isWidgetNeedToReload,
  getComparedWidget,
} from "Utils/widgetsUtils"

const TooltipPRNSN = ({
  onSelectFilterValue,
  onGetWidgetData,
  onCloseTooltip,
  itemSelected,
  tooltipValue,
  tooltipColor,
  clientX,
  clientY,
  isAWidgetFromSettings,
  widgetsData,
  router,
}) => {
  const [comparedWidget, setComparedWidget] = useState({})
  const [dataTooltip, setDataTooltip] = useState(
    makeData(itemSelected?.codePostal?.[0], router?.location?.pathname?.replace("/", ""))
  )

  const location = router?.location?.pathname?.replace("/", "")
  const authorizedWidgetTypeToCompare = [
    "table",
    "lineChart",
    "histogram",
    "stackedBar",
    "counter",
    "radarChart",
    "pieChart",
    "progressBar",
  ]

  useEffect(() => {
    for (let widget of dataTooltip) {
      getWidgetData(
        widget?.widgetInfo,
        widget?.valueFilterSelected,
        widget?.fieldsData,
        widget?.dataChangeType,
        widget?.comparisonValues
      )
    }
  }, [])

  useEffect(() => {
    setDataTooltip(makeData(itemSelected?.codePostal?.[0], location))
  }, [itemSelected])

  useEffect(() => {
    for (let widget of dataTooltip) {
      getWidgetData(
        widget?.widgetInfo,
        widget?.valueFilterSelected,
        widget?.fieldsData,
        widget?.dataChangeType,
        widget?.comparisonValues
      )
    }
  }, [dataTooltip])

  const getWidgetData = (
    widgetInfo,
    valueFilterSelected,
    fieldsData,
    dataChangeType,
    comparisonValues
  ) => {
    const widgetInfosToRequest = widgetInfo

    if (!isWidgetNeedToReload(widgetInfo, dataChangeType)) return
    if (
      !isAWidgetFromSettings &&
      authorizedWidgetTypeToCompare.includes(widgetInfo.widgetType)
    ) {
      if (comparisonValues && Object.keys(comparisonValues).length >= 1) {
        widgetInfosToRequest = getComparedWidget(widgetInfo, comparisonValues, fieldsData)
      }
      setComparedWidget(widgetInfosToRequest)
    }

    const pageFilterAuthorised = getCorrectRelatedPageFilter(
      widgetInfo,
      valueFilterSelected,
      fieldsData
    )
    const dataRequest = generateETLRequestJsonFromWidgetInfo(
      widgetInfo,
      pageFilterAuthorised
    )

    onGetWidgetData({
      widgetType: widgetInfosToRequest?.widgetType,
      widgetId: widgetInfosToRequest._id.$oid,
      dataCatalogueName: "defaultDataCatalogue",
      body: dataRequest,
    })
  }

  const onSetFilter = () => {
    // onSelectFilterValue({
    //   id: "",
    //   value: toNumber(itemSelected?.codePostal?.[0]),
    //   fieldUUID: "excel%Table correspondance Département/Region_Liste des départements français%Département",
    //   operation: "=="
    // })
  }

  return (
    <TooltipContainer left={clientY} top={clientX} id="tooltip_container">
      <Header tooltipColor={tooltipColor} className="tooltip_header">
        {itemSelected?.title?.toUpperCase()}
        <div className="icon" onClick={onCloseTooltip}>
          <i className="fas fa-times" />
        </div>
      </Header>
      <div className="tooltip_bodyPRNSN">
        {getItemTooltip(
          itemSelected?.codePostal?.[0],
          widgetsData,
          location,
          tooltipValue
        )}
        {/* <div className="button_tooltip_PRNSN" onClick={onSetFilter}>
          Filtrer sur ce département
        </div> */}
      </div>
    </TooltipContainer>
  )
}

TooltipPRNSN.propTypes = {
  onSelectFilterValue: PropTypes.func,
  onGetWidgetData: PropTypes.func,
  onCloseTooltip: PropTypes.func,
  itemSelected: PropTypes.object,
  tooltipValue: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  tooltipColor: PropTypes.string,
  clientX: PropTypes.number,
  clientY: PropTypes.number,
  isAWidgetFromSettings: PropTypes.bool,
  widgetsData: PropTypes.array,
}

TooltipPRNSN.defaultProps = {
  onSelectFilterValue: () => {},
  onGetWidgetData: () => {},
  onCloseTooltip: () => {},
  itemSelected: {},
  tooltipColor: "",
  tooltipValue: 0,
  clientX: 0,
  clientY: 0,
  isAWidgetFromSettings: false,
  widgetsData: [],
}

const mapDispatchToProps = dispatch => ({
  onSelectFilterValue: core => dispatch(setFilterValueAction(core)),
  onGetWidgetData: core => dispatch(getWidgetDataAction(core)),
})

const mapStateToProps = () =>
  createStructuredSelector({
    widgetsData: selectActualWidgetsData,
  })

export default compose(connect(mapStateToProps, mapDispatchToProps))(
  withRouter(TooltipPRNSN)
)
